import { StyledText } from "../../assets/typography/typography";
import { PrimaryButton } from "../../components/Buttons";
import { colors } from "../../components/colors";
import { useHandleFetchError } from "../../error-handler";
import { Spinner } from "../common/Spinner";
import { useDeliveryProviderConfigurations } from "../delivery-provider-configurations/service/delivery-provider-configrations-api";

interface IProps {
  organization: string;
  currentProviderIds: string[];
  addShopDeliveryProviderConfiguration: any;
}

export const AddDeliveryProviderInput = ({
  organization,
  currentProviderIds,
  addShopDeliveryProviderConfiguration,
}: IProps) => {
  const {
    data: deliveryProviderConfigurations,
    isLoading: isLoadingDeliveryProviderConfigurations,
    error: deliveryProviderConfigurationsError,
  } = useDeliveryProviderConfigurations(organization);

  useHandleFetchError(deliveryProviderConfigurationsError);

  if (
    isLoadingDeliveryProviderConfigurations ||
    !deliveryProviderConfigurations
  ) {
    return <Spinner />;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        alignItems: "center",
        gap: "16px",
        justifyContent: "center",
      }}
    >
      <div className={"form-group w-100 mt-3"}>
        <StyledText
          color={colors.textPrimary}
          className="bodySubtextSemibold mb-2"
        >
          Add delivery provider
        </StyledText>
        <select
          id="deliveryProviderConfigurationInput"
          className={"form-control"}
        >
          {deliveryProviderConfigurations
            .filter((provider) => !currentProviderIds?.includes(provider.id))
            ?.map((provider) => (
              <option key={provider.id} value={provider.id}>
                {provider.name}
              </option>
            ))}
        </select>
        <StyledText
          color={colors.textSecondary}
          className="bodySubtextRegular mt-2"
        >
          Add delivery provider to the list above and drag to change its
          priority
        </StyledText>
      </div>
      <div className={"form-group"}>
        <PrimaryButton
          type="button"
          color={colors.white}
          backgroundColor={colors.ctaMain}
          hoverColor={colors.ctaSecondaryOne}
          onClick={() => {
            const selectedId = (document.getElementById(
              "deliveryProviderConfigurationInput"
            ) as HTMLSelectElement)?.value;
            if (!selectedId) {
              return;
            }
            addShopDeliveryProviderConfiguration({
              configurationId: selectedId,
              priority: currentProviderIds.length + 1,
              name: deliveryProviderConfigurations.find(
                (p) => p.id === selectedId
              )?.name,
              provider: deliveryProviderConfigurations.find(
                (p) => p.id === selectedId
              )?.provider,
              id: selectedId, // needed internally for draggable field to work, can be random but unique
            });
          }}
        >
          Add
        </PrimaryButton>
      </div>
    </div>
  );
};
